/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { inventoryConvert } from '../../axios/inventoryConvert'
import type {
	InventoryConvertError,
	InventoryConvertPathParams,
	InventoryConvertRequest,
	InventoryConvertResponse,
} from '../../types/InventoryConvert'

export const inventoryConvertMutationKey = () => [{ url: '/:organisation/inventory/convert' }] as const

export type InventoryConvertMutationKey = ReturnType<typeof inventoryConvertMutationKey>

export type InventoryConvertVariables = {
	organisation: InventoryConvertPathParams['organisation']
	data: InventoryConvertRequest
}

/** @see backend/nexus/modules/Billing/Http/Controllers/InventoryController.php InventoryController::convert */
export function useInventoryConvert<TContext = unknown>(
	options?: UseMutationOptions<
		InventoryConvertResponse,
		AxiosError<InventoryConvertError>,
		InventoryConvertVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: inventoryConvertMutationKey(),
		mutationFn: ({ organisation, data }: InventoryConvertVariables) =>
			inventoryConvert(organisation, data, config).then(res => res.data),
		...options,
	})
}
